/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAutocomplete = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16 4h2v16h-2v2h6v-2h-2V4h2V2h-6zM7.524 15.5H6.276l-.245-.89a2.35 2.35 0 0 1-1.987 1.035c-.664-.001-1.188-.181-1.572-.541-.376-.36-.564-.86-.564-1.5 0-.44.112-.82.336-1.14.232-.32.56-.568.984-.744s.92-.264 1.488-.264h1.008v-.216c0-.336-.088-.552-.264-.648-.168-.104-.432-.156-.792-.156-.336 0-.692.04-1.068.12-.368.08-.74.196-1.116.348v-1.44a5.44 5.44 0 0 1 1.152-.336c.44-.088.876-.132 1.308-.132.832 0 1.468.192 1.908.576.448.384.672.932.672 1.644zm-2.568-2.952c-.4 0-.712.076-.936.228a.745.745 0 0 0-.324.648c0 .264.072.468.216.612s.356.216.636.216c.192 0 .368-.036.528-.108.168-.072.32-.172.456-.3a1.62 1.62 0 0 0 .228-.285v-1.011zM14.85 15.5h-1.247l-.262-.96c-.11.14-.226.268-.35.384-.256.24-.544.42-.864.54a2.75 2.75 0 0 1-.996.18c-.704 0-1.248-.224-1.632-.672-.376-.448-.564-1.092-.564-1.932v-3.9h1.92v3.84c0 .36.072.636.216.828.152.184.368.276.648.276.248 0 .48-.08.696-.24.224-.168.396-.392.516-.672V9.14h1.92z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAutocomplete as Autocomplete };
